import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {DataService} from '../data.service';
import {DocumentManagerObj} from 'src/app/features/document-management/document';


@Injectable({
  providedIn: 'root'
})
export class DocumentManagerService extends DataService {

  private baseURI = this.apiUri + '/documentmanager/';

  constructor(http: HttpClient) {
    super(http);
  }

  getDocumentsByOrganizationId(organizationId: any): Observable<any> {
    this.setUri(this.baseURI + organizationId + '/organizationId');
    if (organizationId !== undefined) {
      return this.get(organizationId);
    }
  }

  getDocumentsByBusinessType(businessType: any): Observable<any> {
    this.setUri(this.baseURI + businessType + '/businessType');
    if (businessType !== undefined) {
      return this.get(businessType);
    }
  }

  getFRTTempNonUseTSPsWithNoOrMissingDocs(): Observable<any> {
    this.setUri(this.baseURI + 'frtTempNonUseNoDocTSPs');
      return this.get();
  }

  deleteDocuments(documentManagerId: any): Observable<any> {
    this.setUri(this.baseURI + documentManagerId + '/deleteDocuments/');
    return this.update(documentManagerId);
  }

  saveDocument(docObj: DocumentManagerObj): Observable<any> {
    this.setUri(this.baseURI + 'save/');
    return this.update(docObj);
  }

  saveDocumentStatus(docObj: DocumentManagerObj): Observable<any> {
    this.setUri(this.baseURI + 'saveDocumentStatus/');
    return this.update(docObj);
  }

  finalizedDocumentStatus(docObj: any[]): Observable<any>{
    this.setUri(this.baseURI + 'finalizedDocumentStatus')
    return this.update(docObj)
  }

  getDocumentsByCarrierId(carrierId: any): Observable<any> {
    this.setUri(this.baseURI + carrierId + '/carrierId');
    if (carrierId !== undefined) {
      return this.get(carrierId);
    }
  }
}
